module.exports = __webpack_public_path__ + "static/reward-modal-bg.7cd88960.png";